import { Cancellable } from '@infrastructure/axios';
import { IUserService, UserDashboardInfo } from '../../types';
import { IGetAllContractUseCase } from '@core/domain/Contract/use-cases/GetAllContracts';
import { IGetAllInvoiceUseCase } from '@core/domain/Invoice/use-cases/GetAllInvoices';

// Better progrom again interfece instance i
export default class GetUserDashboardInfoUseCase extends Cancellable {
  constructor(private invoiceService: IUserService, private getAllContractUseCase: IGetAllContractUseCase , private getAllInvoices : IGetAllInvoiceUseCase ) {
    super();
  }

  public async execute(): Promise<UserDashboardInfo> {
    const contract = await this.getAllContractUseCase.execute({ page: 1, pageSize: 2 });
    const invoices = await this.invoiceService.getUserLastFiveInvoice(this.controller);
    const lastFiveInvoices = await this.getAllInvoices.execute({ page: 1, pageSize: 5   })
    const response = { invoices: invoices, contracts: contract , lastFiveInvoices: lastFiveInvoices}
    return response;
  }
}
